import { render, staticRenderFns } from "./ObjectValue.vue?vue&type=template&id=44477973"
import script from "./ObjectValue.vue?vue&type=script&lang=js"
export * from "./ObjectValue.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports